export function convertObjToArr(obj: any): any[] {
    return Object.keys(obj).map(function (key) { return obj[key]; });
}